import { http } from 'services';

export const Download = ({ uuid })=> http.request.get(`/v1/gov-function/reference/download/${uuid}`, {
  responseType: 'blob'
});
